import { render } from "./election.vue?vue&type=template&id=6c960752&scoped=true"
import script from "./election.vue?vue&type=script&lang=js"
export * from "./election.vue?vue&type=script&lang=js"

import "./election.vue?vue&type=style&index=0&id=6c960752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c960752"]])

export default __exports__